import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconSuitcase20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconSuitcase20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M8.9 2.5h2.2a1 1 0 0 1 1 1V5H7.9V3.5a1 1 0 0 1 1-1M6.4 5V3.5A2.5 2.5 0 0 1 8.9 1h2.2a2.5 2.5 0 0 1 2.5 2.5V5h2.9A2.5 2.5 0 0 1 19 7.5v8a2.5 2.5 0 0 1-2.5 2.5h-13A2.5 2.5 0 0 1 1 15.5v-8A2.5 2.5 0 0 1 3.5 5zm.1 1.5v3.7a1.5 1.5 0 0 1 0 2.6v3.7h7v-3.7a1.5 1.5 0 0 1 0-2.6V6.5zm8.5 6.3a1.5 1.5 0 0 0 0-2.6V6.5h1.5a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H15zM5 6.5v3.7a1.5 1.5 0 0 0 0 2.6v3.7H3.5a1 1 0 0 1-1-1v-8a1 1 0 0 1 1-1z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconSuitcase20);
